'use client'

import fetchDoc from '@/lib/client/fetchDoc'
import { useEffect, useState } from 'react'

export default function useDoc(collection: string, id?: null | string | any) {
  const [data, setData] = useState<any | null | undefined>(undefined)
  useEffect(() => {
    if (!id) {
      return
    }
    if (typeof id !== 'string') {
      setData(id)
      return
    }
    fetchDoc(collection, id)
      .then(setData)
  }, [id, collection])
  return data
}


